module.exports = __webpack_public_path__ + "img/pic19.07464af6.jpg";